import EventBus from '@/helpers/event-bus'
const lib = 'facebook'
export const EVENTS = {
  READY: lib + '.ready',
  WAITING: lib + '.waiting',
  SUCCESS: lib + '.success',
  FAILED: lib + '.failed',
  LOGIN: lib + '.login',
  LOGOUT: lib + '.logout'
}

export default (function () {
  var config = null
  var failoverLang = 'es_LA'
  var id = 'facebookjs-sdk'
  var apiUrl = '//connect.facebook.net/<LANG>/sdk.js'
  var versionAPI = 'v2.9'

  function Auth () {
    return {
      init: (api, lang) => {
        if (!lang) {
          lang = failoverLang
        }

        apiUrl.replace('<LANG>', lang)
        config = {
          appId: api,
          cookie: true,
          xfbml: true,
          version: versionAPI
        }

        window.fbAsyncInit = () => {
          /* eslint-disable */
          FB.init(config)
        }

        return new Promise(function (resolve, reject) {
          try {
            /* eslint-disable */
            if (IN === undefined) {
              loadJS().then(function () {
                return initClient()
              }).then(function () {
                resolve()
              })
            /* eslint-disable */
            } else if (IN !== undefined && IN.init === undefined) {
              initClient().then(function () {
                resolve()
              })
            }
          } catch (e) {
            loadJS().then(function () {
              console.log('* Load *')
              return initClient()
            }).then(function () {
              resolve()
            })
          }
        })
      },
      singIn: () => {
        try {
          /* eslint-disable */
          FB.login(function (response) {
            checkStatus(response)
          }, {
            scope: 'public_profile, email'
          })
        } catch (e) {
          console.log('Not ready yet', e)
          EventBus.$emit(EVENTS.FAILED, 'Aún estamos cargando, por favor espere...')
        }
      },
      singOut: () => {
        try {
          /* eslint-disable */
          FB.logout(function (response) {
            EventBus.$emit(EVENTS.LOGOUT)
          })
        } catch (e) {
          console.log('Not ready', e)
          EventBus.$emit(EVENTS.FAILED, 'Aún estamos cargando, por favor espere...')
        }
      }
    }
  }

  function loadJS () {
    return new Promise(function (resolve, reject) {
      var head = document.getElementsByTagName('head')[0]
      if (document.getElementById(id)) return
      var script = document.createElement('script'); script.id = id
      script.async = false
      script.src = apiUrl
      script.onload = function () {
        if (!script.readyState || /loaded|complete/.test(script.readyState)) {
          setTimeout(function () {
            resolve()
          }, 500)
        }
      }
      head.appendChild(script)
    })
  }

  function initClient () {
    return new Promise(function (resolve, reject) {
      /* eslint-disable */
      FB.getLoginStatus(function (response) {
        checkStatus(response)
      })
      EventBus.$emit(EVENTS.READY)
      console.log('Ready')
      resolve()
    })
  }

  function checkStatus(response) {
    EventBus.$emit(EVENTS.LOGIN)
    /* eslint-disable */
    if (response.status === 'connected') {
      let person
      /* eslint-disable */
      FB.api('/me?fields=id,email,first_name,last_name', function (data) {
        person = data
        /* eslint-disable */
        FB.api('/' + data.id + '/picture?redirect=false&type=large?redirect=false&type=large', function (image){
          person['image'] = image.data.url
          EventBus.$emit(EVENTS.SUCCESS, person)
        })
      })
    } else if (response.status === 'not_authorized') {
      EventBus.$emit(EVENTS.FAILED, 'not_authorized ' + response)
    // } else {
    //   EventBus.$emit(EVENTS.FAILED, response)
    }
  }

  return Auth
})()



// WEBPACK FOOTER //
// ./src/helpers/facebook.js